import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export const screenFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'PARTNER_NAME_KEY',
    stateKey: 'name',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'ALIAS_KEY',
    stateKey: 'alias',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'LANGUAGE_KEY',
    stateKey: 'frontend.language',
    isSelect: true,
    options: [
      { value: 'pt-br', label: 'LANGUAGES.PORTUGUESE_KEY' },
      { value: 'en', label: 'LANGUAGES.ENGLISH_KEY' },
      { value: 'es', label: 'LANGUAGES.SPANISH_KEY' },
    ],
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'COMPANY_KEY',
    stateKey: 'company_uuid',
    isSelect: true,
    options: [],
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'PARTNER_PAGE.CLOUD_PROVIDER_PARTNER_KEY',
    stateKey: 'use_cloud',
    isSelect: true,
    multipleSelect: true,
    options: [
      { value: 'aws', label: 'AMAZON_WEB_SERVICES_KEY' },
      { value: 'oci', label: 'ORACLE_CLOUD_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.SELECT_LDAP_PARTNER_KEY',
    stateKey: 'active_directory.ldap_type',
    isSelect: true,
    options: [
      { value: 'internal', label: 'INTERNAL_KEY' },
      { value: 'external', label: 'EXTERNAL_KEY' },
      { value: 'managed', label: 'MANAGED_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.USE_NEW_FRONT_KEY',
    stateKey: 'frontend.enable_new_interface',
    isSelect: true,
    options: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.CUSTOMER_EMAIL_KEY',
    stateKey: 'use_email',
    isSelect: true,
    options: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.CUSTOMER_PLUGIN_KEY',
    stateKey: 'use_plugin',
    isSelect: true,
    options: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.TEMPLATE_EMAIL_PARTNER_KEY',
    stateKey: 'use_template',
    isSelect: true,
    options: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'MANAGE_ENV_LICENSE_LIMIT_KEY',
    stateKey: 'enforce_env_license_limit',
    isCheckbox: true,
  },
  {
    gridXs: 12,
    label: 'MANAGE_CHANGE_PASSWORD_KEY',
    stateKey: 'active_directory.can_external_ad_change_password',
    isCheckbox: true,
  },
];

export const cloudFields: {
  aws: GenericFormItem[];
  gcp: GenericFormItem[];
  oci: GenericFormItem[];
} = {
  aws: [
    {
      gridXs: 6,
      label: 'Role arn',
      stateKey: 'role_arn',
      validateOnChange: true,
    },
    {
      gridXs: 6,
      label: 'AWS Owner ID',
      stateKey: 'owner_id',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      label: 'External ID',
      stateKey: 'external_id',
    },
  ],
  gcp: [
    {
      gridXs: 12,
      label: 'Project Code',
      stateKey: 'gcp_project_code',
      validateOnChange: true,
    },
  ],
  oci: [
    {
      gridXs: 3,
      label: 'Tenancy',
      stateKey: 'profile_name',
      validateOnChange: true,
      isSelect: true,
      options: [
        { value: 'DEFAULT', label: 'Skyone Cloud 01' },
        { value: 'SKYONECLOUD02', label: 'Skyone Cloud 02' },
        { value: 'SKYONECLOUD03', label: 'Skyone Cloud 03' },
        { value: 'PARCEIRO-SIESA', label: 'Parceiro Siesa' },
        { value: 'PARCEIRO-DMA', label: 'Parceiro DMA' },
        { value: 'PARCEIRO-NSTECH', label: 'Parceiro NSTech' },
      ],
    },
    {
      gridXs: 12,
      label: 'Compartment id',
      stateKey: 'compartment_id',
      validateOnChange: true,
    },
  ],
};

export const activeDirectoryFields: GenericFormItem[] = [
  {
    gridXs: 12,
    gridMd: 6,
    label: 'LDAP Server',
    stateKey: 'active_directory.ldap_server',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'LDAP Server Backup',
    stateKey: 'active_directory.ldap_server_backup',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'PARTNER_PAGE.ADMIN_DN_KEY',
    stateKey: 'active_directory.admin_bind_dn',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'PARTNER_PAGE.ADMIN_BIND_PASS_KEY',
    stateKey: 'active_directory.admin_bind_pass',
    isPassword: true,
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'Base DN',
    stateKey: 'active_directory.base_dn',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'PARTNER_PAGE.AD_DOMAIN_KEY',
    stateKey: 'active_directory.ad_domain',
  },
];

export const emailFields: GenericFormItem[] = [
  {
    gridXs: 12,
    gridMd: 6,
    label: 'From e-mail',
    stateKey: 'email_from',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'DOMAIN_KEY',
    stateKey: 'email_domain',
  },
  {
    gridXs: 12,
    label: 'SUBJECT_KEY',
    stateKey: 'email_subject',
  },
];

export const pluginFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'URL Plugin',
    stateKey: 'url_plugin',
  },
  {
    gridXs: 12,
    label: 'URL Loading Plugin',
    stateKey: 'url_return',
  },
];

export const templateFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.SELECT_TEMPLATE_PARTNER_KEY',
    stateKey: 'choose_template',
  },
  {
    gridXs: 12,
    label: 'PARTNER_PAGE.SUBJECT_EMAIL_PARTNER_KEY',
    stateKey: 'subject_email',
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'HTML Template',
    stateKey: 'html_template',
    isMultiline: true,
    multilineMinRows: 1,
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'TEXT Template',
    stateKey: 'text_template',
    isMultiline: true,
    multilineMinRows: 1,
  },
];

export const changeAdPasswordFields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'NEW_PASSWORD_KEY',
    stateKey: 'new_ad_password',
    isPassword: true,
  },
  {
    gridXs: 12,
    label: 'CONFIRM_NEW_PASSWORD_KEY',
    stateKey: 'new_ad_password_confirmation',
    isPassword: true,
  },
  {
    gridXs: 12,
    label: 'REASON_KEY',
    stateKey: 'action_reason',
  },
];
